import queryString from 'query-string'
import omit from 'lodash.omit'

export const queryStringToObject = (str, options = {}) =>
  queryString.parse(str, {
    arrayFormat: 'bracket',
    ...options,
  })

export const objectToQueryString = (obj, options = {}) =>
  queryString.stringify(obj, {
    arrayFormat: 'bracket',
    ...options,
  })

export const omitFromQueryString = (str, keys) =>
  objectToQueryString(omit(queryStringToObject(str), keys))

export const addToQueryString = (str, fields) =>
  objectToQueryString({
    ...queryStringToObject(str),
    ...fields,
  })

export const buildUpdatedReturnUri = (oldUrl, currentPage) => {
  if (!oldUrl) {
    return undefined
  }
  let authUrl = new URL(oldUrl)
  const searchParams = authUrl.searchParams
  searchParams.set('returnUri', currentPage)
  authUrl.search = searchParams.toString()
  authUrl = authUrl.toString()

  return authUrl
}

export const buildSwitchUserUrl = (oldUrl, currentPage) => {
  if (!oldUrl) {
    return undefined
  }
  let switch_user_url = new URL(oldUrl)
  const switchUserSearchParams = switch_user_url.searchParams

  let reloginUrl = new URL(switchUserSearchParams.get('returnUri'))
  const reloginUrlSearchParams = reloginUrl.searchParams

  const returnUriAfterRelogin = new URL(
    reloginUrlSearchParams.get('returnUri'),
  )
  const newReturnUriAfterRelogin = new URL(
    currentPage + returnUriAfterRelogin.search,
  )

  reloginUrlSearchParams.set('returnUri', newReturnUriAfterRelogin)
  reloginUrl.search = reloginUrlSearchParams.toString()
  reloginUrl = reloginUrl.toString()

  switchUserSearchParams.set('returnUri', reloginUrl)
  switch_user_url.search = switchUserSearchParams.toString()
  switch_user_url = switch_user_url.toString()

  return switch_user_url
}
